/* 
 * To change this template, choose Tools | Templates
 * and open the template in the editor.
 */

var Sidebar_gallery = new Class({
    Implements : [Options, Events],
    loadedThemes : [],
    loadedEls : [],
    ImplementObserver: GS.Observer,
    queues : {
        samples : {
            queue : [],
            totalEls : 0,
            loading : 0
        },
        layouts : {
            queue : [],
            totalEls : 0,
            loading : 0
        },
        graphics : {
            queue : [],
            totalEls : 0,
            loading : 0
        },
        backgrounds : {
            queue : [],
            totalEls : 0,
            loading : 0
        }
    },
    queue : [],
    loading : 0,
    totalSamples : 0,
    max_concurrent : 1,
    loadingTheme : {
        cover : null,
        internal : null
    },
    textureMagnifier : null,
    containers : {
        layouts : {
            internal : {
                "double" : 'tab_layouts_double',
                "single" : 'tab_layouts_single'
            },
            cover : {
                "double" : 'tab_cover_layouts_double',
                "single" : 'tab_cover_layouts_single'
            }
        },
        graphics : {
            decors : "decors",
            frames : "frames"
        },
        backgrounds : {
            double : "spreadpage_back",
            single : "singlepage_back"
        }
    },
    binds : {},
    showingBookPart : 'cover',
    allAddingTheme : {
        cover : null,
        internal : null
    },
    initialize : function(options){
            this.setOptions(options);
            this.loadedThemes[0] = this.options.defaultTheme;
            this.textureMagnifier = new Element('div',{
                "class" : 'texture-magnifier',
                "html" : "<div class=\"close_btn\">&nbsp;</div><div class=\"texture-magnifier-id\">Test</div>",
                styles : {
                    "display" : 'none'
                },
                events : {
                    'click' : function(){
                        this.hide();
                    }
                }
            });
            document.body.adopt(this.textureMagnifier);
            this.addEvents();
    },
    addEvents : function(){
        window.addEvent('leftbar:initialize',this.loadAllSampleByFormat.bind(this));
        //questo è ok
        this.binds.loadAllSamplesByFormat = this.loadAllSampleByFormat.bind(this);
        window.addEvent('samples::loadAllByFormat',this.binds.loadAllSamplesByFormat);
        this.binds.loadAllGraphicsByFormat = this.loadAllGraphicsByFormat.bind(this);
        window.addEvent('graphics::loadAllByFormat',this.binds.loadAllGraphicsByFormat);
        this.binds.loadAllBackgroundsByFormat = this.loadAllBackgroundsByFormat.bind(this);
        window.addEvent('backgrounds::loadAllByFormat',this.binds.loadAllBackgroundsByFormat);
        this.binds.loadAllLayoutsByFormat = this.loadAllLayoutsByFormat.bind(this);
        window.addEvent('layouts::loadAllByFormat',this.binds.loadAllLayoutsByFormat);
        this.binds.hideTextureMagnifier = this.hideTextureMagnifier.bind(this);
        window.addEvent('sidebar::hideTextureMagnifier',this.binds.hideTextureMagnifier);
        this.binds.showProperElements = this.showProperElements.bind(this);
        window.addEvent('sidebar::content:set',this.binds.showProperElements);
        this.binds.loadAllLayoutsByFormatNew = this.loadAllLayoutsByFormatNew.bind(this);
        window.addEvent('layouts::loadAllByFormatNew',this.binds.loadAllLayoutsByFormatNew);
    },
    loadAllSampleByFormat : function(data) {
        var self = this;

        if(currentDesign.hide_internal_pages) {
            return;
        }
        if(self.loadedEls.indexOf('samples') != -1){
            return;
        }
        self.loadedEls.push('samples');
        var myJSONRemote = new Request.JSON({
            url : '/app/get_all_samples_by_format/'+data.format,
            onRequest : function(){
                var loader = new Element('div',{
                    'class' : 'samples_loader_big',
                    'html' : '<img class="samples_loader" src="../images/interface/loaders/oval.svg"><div class="loading_progress_indicator">0%</div>'
                });
                if(!$('tab_samples')) return;
                $('tab_samples').adopt(loader);
            },
            onSuccess : function(a){
                var els = {
                    internal : {
                        single : $$('#tab_samples_single_text .items_list'),
                        double : $$('#tab_samples_double_text .items_list')
                    },
                    cover : {
                        single : $$('#tab_cover_samples_single_text .items_list'),
                        double : $$('#tab_cover_samples_double_text .items_list')
                    }
                }
                if(Object.keys(a.samples).length == 0){
                    $$('.samples_loader_big').fade('out');
                }

                Object.each(a.samples,function(value,key){
                    if(key != "cover" || currentDesign.product_type != 3){
                        Object.each(value,function(val,chiave){
                            var sorted = Object.keys(val).sort(function(a,b){
                                var string1 = a;
                                var string2 = b;
                                var matches1 = string1.match(/(\d+)/);
                                var matches2 = string2.match(/(\d+)/);
                                if(matches1 && matches2){
                                    var a1 = parseInt(matches1[0]);
                                    var a2 = parseInt(matches2[0]);
                                    return a1 - a2;
                                } else {
                                    if (a<b) return -1;
                                    if (a>b) return 1;
                                    return 0;
                                }
                            });
                            var container = els[key][chiave];
                            try {
                                container[0].getParent().getElements('.empty_el').dispose();
                            } catch (err) {}
                            Array.each(sorted,function(theme,index){
                                var lblElCnt = new Element('div',{
                                    'data-theme' : theme,
                                    'class' : 'theme-container',
                                    'data-sampletype' : chiave
                                });
                                var lblEl = new Element('div',{
                                    html : theme,
                                    class : 'themeLabel',
                                    styles : {
                                        cursor : 'pointer'
                                    },
                                    events : {
                                        'click' : function () {
                                            if(this.getParent().getElements('a').length <= 1){
                                                return;
                                            }
                                            if(this.getElements('.fa')[0].hasClass('fa-minus-square')){
                                                this.getElements('.fa')[0].set('class','fa fa-plus-square');
                                                this.getParent().removeClass('not-display-after');
                                            } else {
                                                this.getElements('.fa')[0].set('class','fa fa-minus-square');
                                                this.getParent().addClass('not-display-after');
                                            }
                                            this.getParent().getElements('a:not(:first-of-type)').toggle();
                                        }
                                    }
                                });
                                var openIcon = new Element('i',{
                                    class : 'fa fa-plus-square',
                                    styles : {
                                        position : 'relative',
                                        left : '10px',
                                        float : 'left'
                                    }
                                });
                                lblElCnt.adopt(lblEl.adopt(openIcon));
                                container.adopt(lblElCnt);
                                var sortedEl = val[theme].sort(function(a,b){
                                    if (a.code<b.code) return -1;
                                    if (a.code>b.code) return 1;
                                    return 0;
                                })
                                Array.each(sortedEl,function(chiave2){
                                        this.totalSamples++;
                                        this.addToQueue(chiave2);    
                                }.bind(self));
                            });
                        });
                    }
                })
            }.bind(this)
        }).post();
    },
    loadAllGraphicsByFormat : function(data){
        var self = this;
        if(self.loadedEls.indexOf('graphics') != -1){
            return;
        }
        self.loadedEls.push('graphics');
        var myJSONRemote = new Request.JSON({
            url: 'https://orderform.graphistudio.com/app/get_all_graphics_by_format/'+data.format,
            onRequest : function(){
                var loader = new Element('div',{
                    'class' : 'samples_loader_big',
                    'html' : '<img class="samples_loader" src="../images/interface/loaders/oval.svg"><div class="loading_progress_indicator">0%</div>'
                });
                $('tab_graphics').adopt(loader);
            },
            onSuccess : function(a){
                this.buildGraphics(a);
            }.bind(this)
        }).post();
    },
    loadAllBackgroundsByFormat : function(data){
        var self = this;
        if(self.loadedEls.indexOf('backgrounds') != -1){
            return;
        }
        self.loadedEls.push('backgrounds');
        var myJSONRemote = new Request.JSON({
            url: 'https://orderform.graphistudio.com/app/get_all_backgrounds_by_format/'+data.format,
            onRequest : function(){
                var loader = new Element('div',{
                    'class' : 'samples_loader_big',
                    'html' : '<img class="samples_loader" src="../images/interface/loaders/oval.svg"><div class="loading_progress_indicator">0%</div>'
                });
                $('tab_backgrounds').adopt(loader);
            },
            onSuccess : function(a){
                this.buildBackgrounds(a);
            }.bind(this)
        }).post();
    },
    loadAllLayoutsByFormat : function(data){
        var myJSONRemote = new Request.JSON({
            url: 'https://orderform.graphistudio.com/app/get_all_layouts_by_format/'+data.format,
            onRequest : function(){
                var loader = new Element('div',{
                    'class' : 'samples_loader_big',
                    'html' : '<img class="samples_loader" src="../images/interface/loaders/oval.svg"><div class="loading_progress_indicator">0%</div>'
                });
                $('tab_layouts').adopt(loader);
            },
            onSuccess : function(a){
                this.buildLayouts(a.layouts,"layouts");
            }.bind(this)
        }).post();  
    },
    loadAllLayoutsByFormatNew : function(data){
        console.warn('LOAD ALL LAYOUTS BY FORMAT NEW:', data);

        var url = 'https://orderform.graphistudio.com/designer/layouts';
        var wrapper = document.querySelector('#tab_layouts');
        var myJSONRemote = new Request.JSON({
            url: url,
            onRequest : function(){
                if(wrapper) {
                    var loader = document.createElement('div');
                    loader.className = 'samples_loader_big';
                    loader.innerHTML = '<img class="samples_loader" src="../images/interface/loaders/oval.svg"><div class="loading_progress_indicator">0%</div>';
                    wrapper.appendChild(loader);
                }

            },
            onSuccess : function(a){
                console.warn(a);
                //this.buildLayouts(a.layouts,"layouts");
            }.bind(this)
        }).post({'format': data.format, 'type': data.type });
    },
    addToQueue : function ( obj ){
        var self = this,_next, _onComplete = function(){
            self.loading-=1;
            self.loading = Math.max(self.loading,0);
            _next = self.queue.shift();
            if(_next){
                self.loading += 1;
                self.createSampleContainer(_next,_onComplete);
                $$('.loading_progress_indicator').set('html',parseInt((self.totalSamples - self.queue.length) / self.totalSamples * 100)+"%");
            } else {
                $$('[data-theme] a:first-of-type').show();
                $$('.samples_loader_big').fade('out');
            }
        };
        if(this.loading+1<=this.max_concurrent){
            this.loading+=1;
            self.createSampleContainer(obj,_onComplete);
        }else{
            this.queue.push(obj);
        }
    },
    createSampleContainer : function(obj,_callback){
        var _that = this;
        var isCover = obj.is_cover === "cover" ? "_cover" : "" ; //tab_cover_samples_double_text
        var containerID = 'tab'+isCover+'_samples'+"_"+obj.type+"_text";
        var container = $$('#'+containerID+' [data-theme='+obj.theme_name+']');
        var img = new Element('img',{
            src : obj.image ? obj.image : '/designer/img/gs/item.png',
            styles : {
                width : obj.type === "double" ? 130 : 65
            }
        });
        img.addEvent('load',_callback);
        img.addEvent('dragstart',function(e){
            var immagine = e.target;
            try{
                var evt = e.event;
                var effectJson = JSON.decode('['+obj.data+']');
                evt.dataTransfer.setData('layouts_data', JSON.encode(effectJson));
                evt.dataTransfer.setData('subtype','samples');
                evt.dataTransfer.setData('data', JSON.encode(effectJson));
                evt.dataTransfer.setData('type',obj.type);
            }catch(err){
                alert('Unable to use this element: definition incorrect!');
            }
        });
        var imageViewerIcon = new Element('img',{
            src : url_site+'images/interface/lens.png',
            styles : {
                width: 15,
                height: 15,
                position: 'absolute',
                bottom: 0,
                right: 0,
                cursor : 'pointer'
            }
        });
        imageViewerIcon.addEvent('click',function(el){
            _that.textureMagnifier.show();
            var clickPosition = el.target.getPosition();
            var btnSize = el.target.getSize();
            _that.textureMagnifier.getElements('.texture-magnifier-id').set('html',Locale.get('TextureMagnifier').code+" : "+obj.code);
            _that.textureMagnifier.getElements('img').dispose();
            var pattern = /(\-low.jpg|_sample-low.jpg)/;
            var fullImage = obj.image.replace(pattern,"_sample-med.jpg");
            var tramina = new Element('img',{
                'src' : fullImage,
                events : {
                    'load' : function(){
                        _that.textureMagnifier.setStyles({
                            'height' : 3 + tramina.getSize().y + 25 ,
                            'width' : tramina.getSize().x + 6
                        });
                        var windowSize = window.getSize();
                        var newPosition = {
                            x : clickPosition.x + btnSize.x + 10,
                            y : clickPosition.y
                        };
                        if(newPosition.y + tramina.getSize().y > window.getSize().y){
                            newPosition.y = window.getSize().y - ( tramina.getSize().y + 25 ) - 20;
                        }
                        _that.textureMagnifier.setPosition(newPosition);    
                    }
                }
            });
            _that.textureMagnifier.adopt(tramina);
        });
        var a = new Element('a',{
            styles : {
                display : 'none'
            }
        }).adopt([img,imageViewerIcon]);
        container.adopt(a);
        var spcCnt = "tab"+isCover+"_samples_"+obj.type+"_"+Math.min(obj.category,5);
        var clone = new Element('a');
        Array.each(a.getChildren(),function(el,index){
            var cloneCld = el.clone().cloneEvents(el);
            clone.adopt(cloneCld);
        });
        if($(spcCnt)) {
            $(spcCnt).getElements('.empty_el').dispose();
            $(spcCnt).getElements('.items_list').adopt(clone);
        }
    },
    addToAll : function(data,params){
        var _that = this;
        var type = params.type;
        var containers = {
            cover : {
                single : $(_that.options.samples_cover_container_prefix+"single_text").getElements(".items_list")[0], 
                double : $(_that.options.samples_cover_container_prefix+"double_text").getElements(".items_list")[0]
            },
            internal : {
                single : $(_that.options.samples_container_prefix+"single_text").getElements(".items_list")[0], 
                double : $(_that.options.samples_container_prefix+"double_text").getElements(".items_list")[0]
            }
        };
        Object.each(data[type],function(part,partKey){
            Object.each(part,function(el,key){
                Object.each(el,function(element,pageType){
                    all_container_sub = containers[partKey][pageType];
                    if(params.theme_name && _that.allAddingTheme[partKey] !== params.theme_name){
                        _that.allAddingTheme[partKey] = params.theme_name;
                        var theme_title_container = new Element('div',{
                            html : params.theme_name,
                            'class' : 'themeLabel '+params.theme_id 
                        });
                        try{
                            var _toRemove = all_container_sub.getParent().getElements('.empty_el');
                            if(_toRemove.length>0) _toRemove.dispose();
                        }catch(err){}
                        all_container_sub.adopt(theme_title_container);
                    }
                    Array.each(element,function(arrayEl,indexEl){
                            var img = new Element('img',{
                                src : arrayEl.image ? arrayEl.image : '/designer/img/gs/item.png',
                                styles : {
                                    width : pageType === "double" ? 130 : 65
                                }
                            });
                            img.ondragstart = function(e){
                                console.info('estica');
                                var immagine = e.target;
                                try{
                                    var effectJson = JSON.decode('['+arrayEl.data+']');
                                    e.dataTransfer.setData('layouts_data', JSON.encode(effectJson));
                                    e.dataTransfer.setData('subtype',type);
                                    e.dataTransfer.setData('data', JSON.encode(effectJson));
                                    e.dataTransfer.setData('type',pageType);
                                }catch(err){
                                    alert('Unable to use this element: definition incorrect!');
                                }
                            };
                            var a = new Element('a').adopt(img);
                            if(type === "samples"){
                                var imageViewerIcon = new Element('img',{
                                    src : url_site+'images/interface/lens.png',
                                    styles : {
                                        width: 15,
                                        height: 15,
                                        position: 'absolute',
                                        bottom: 0,
                                        right: 0,
                                        cursor : 'pointer'
                                    }
                                });
                                imageViewerIcon.addEvent('click',function(el){
                                    _that.textureMagnifier.show();
                                    var clickPosition = el.target.getPosition();
                                    var btnSize = el.target.getSize();
                                    _that.textureMagnifier.getElements('.texture-magnifier-id').set('html',Locale.get('TextureMagnifier').code+" : "+arrayEl.code);
                                    _that.textureMagnifier.getElements('img').dispose();
                                        var pattern = /(\-low.jpg|_sample-low.jpg)/;
                                        var fullImage = arrayEl.image.replace(pattern,"_sample-med.jpg");
                                    var tramina = new Element('img',{
                                        'src' : fullImage
                                    });
                                    _that.textureMagnifier.adopt(tramina);
                                    tramina.addEvent('load',function(){
                                        _that.textureMagnifier.setStyles({
                                            'height' : 3 + tramina.getSize().y + 25 ,
                                            'width' : tramina.getSize().x + 6
                                        });
                                        var windowSize = window.getSize();
                                        var newPosition = {
                                            x : clickPosition.x + btnSize.x + 10,
                                            y : clickPosition.y
                                        };
                                        if(newPosition.y + tramina.getSize().y > window.getSize().y){
                                            newPosition.y = window.getSize().y - ( tramina.getSize().y + 25 ) - 20;
                                        }
                                        _that.textureMagnifier.setPosition(newPosition);
                                    });
                                    
                                    
                                    
                                }.bind(this));
                                if(all_container_sub) all_container_sub.adopt(a.adopt(imageViewerIcon));
                            } else {
                                if(all_container_sub) all_container_sub.adopt(a);
                            }
                        });
                });
            });
        });
    },
    showProperElements : function(elType){
        if(elType == this.showingBookPart) return;
        this.showingBookPart = elType;
        switch (elType){
            case 'cover':    
                Array.each($$('.contenuto'),function(el,index){
                    if( $j(el).parent().attr('id') == 'tab_samples' || $j(el).parent().attr('id') == 'tab_layouts' ) {
                        el.hide();
                    } else {
                        el.show();
                    }
                });
                $$('.contenuto_covers').show();
                break;
            case 'youngbox-internal':
            case 'double':
                $$('.contenuto_covers').hide();
                $$('.contenuto').show();
                break;
        }
    },
    hideTextureMagnifier : function(){
        this.textureMagnifier.hide();
    },
    //nuove funzioni
    addToProperQueue : function(data,params){
        var _that = this,_next, queueObj = _that.queues[params.queueName],_onComplete = function(){
            queueObj.loading -= 1 ;
            queueObj.loading = Math.max(queueObj.loading,0);
            _next = queueObj.queue.shift();
            if(_next){
                queueObj.loading += 1;
                _that["create"+params.queueName.capitalize()+"Container"](_next,_onComplete);
                $('tab_'+params.queueName).getElements('.loading_progress_indicator').set('html',parseInt((_that.queues[params.queueName].totalEls - _that.queues[params.queueName].queue.length) / _that.queues[params.queueName].totalEls * 100)+"%");
            } else {
                var loader = $('tab_'+params.queueName).getElements('.samples_loader_big');
                if(loader.length > 0) loader.fade('out');
            }
        };
        if(queueObj.loading+1 <= _that.max_concurrent){
            queueObj.loading++;
            _that["create"+params.queueName.capitalize()+"Container"](data,_onComplete);
        } else {
            data.container = params.container_string;
            queueObj.queue.push(data)
        }
    },
    createGraphicsContainer : function(obj,_callback){
        var _that = this;
        var container = $(obj.stringContainer).getElements('.items_list')[0];
        try{
            var _toRemove = container.getParent().getElements('.empty_el');
            if(_toRemove.length>0) _toRemove.dispose();
        }catch(err){}
        var img = new Element('img',{
            src : obj.image ? obj.image : '/designer/img/gs/item.png',
            styles : {
                width : obj.type === "double" ? 130 : 65
            },
            events : {
                load : _callback,
                dragstart : function(e){
                    var immagine = e.target;
                    try{
                        var effectJson = JSON.decode('['+obj.data+']');
                        e.event.dataTransfer.setData('graphics_data', JSON.encode(effectJson));
                        e.event.dataTransfer.setData('subtype',"graphics");
                        e.event.dataTransfer.setData('data', JSON.encode(effectJson));
                        e.event.dataTransfer.setData('type',obj.type);
                    }catch(err){
                        alert('Unable to use this element: definition incorrect!');
                    }
                }
            }
        });
        var a = new Element('a',{ class : 'graphic_el'}).adopt(img);
        container.adopt(a);
    },
    createBackgroundsContainer : function(obj,_callback){
        var _that = this;
        var container = $(obj.stringContainer).getElements('.items_list')[0];
        try{
            var _toRemove = container.getParent().getElements('.empty_el');
            if(_toRemove.length>0) _toRemove.dispose();
        }catch(err){}
        var img = new Element('img',{
            src : obj.image ? obj.image : '/designer/img/gs/item.png',
            styles : {
                width : obj.type === "double" ? 130 : 65
            },
            events : {
                load : _callback,
                dragstart : function(e){
                    var immagine = e.target;
                    try{
                        var effectJson = JSON.decode('['+obj.data+']');
                        e.event.dataTransfer.setData('graphics_data', JSON.encode(effectJson));
                        e.event.dataTransfer.setData('subtype',"backgrounds");
                        e.event.dataTransfer.setData('data', JSON.encode(effectJson));
                        e.event.dataTransfer.setData('type',obj.type);
                    }catch(err){
                        alert('Unable to use this element: definition incorrect!');
                    }
                }
            }
        });
        var imageViewerIcon = new Element('img',{
            src : url_site+'images/interface/lens.png',
            styles : {
                width: 15,
                height: 15,
                position: 'absolute',
                bottom: 0,
                right: 0,
                cursor : 'pointer'
            }
        });
        imageViewerIcon.addEvent('click',function(el){
            _that.textureMagnifier.show();
            var clickPosition = el.target.getPosition();
            var btnSize = el.target.getSize();
            _that.textureMagnifier.getElements('.texture-magnifier-id').set('html',Locale.get('TextureMagnifier').code+" : "+obj.code);
            _that.textureMagnifier.getElements('img').dispose();
                var pattern = /(\-low.jpg|_sample-low.jpg)/;
                var fullImage = obj.image.replace(pattern,"-med.jpg");
            var tramina = new Element('img',{
                'src' : fullImage
            });
            _that.textureMagnifier.adopt(tramina);
            tramina.addEvent('load',function(){
                _that.textureMagnifier.setStyles({
                    'height' : 3 + tramina.getSize().y + 25 ,
                    'width' : tramina.getSize().x + 6
                });
                var windowSize = window.getSize();
                var newPosition = {
                    x : clickPosition.x + btnSize.x + 10,
                    y : clickPosition.y
                };
                if(newPosition.y + tramina.getSize().y > window.getSize().y){
                    newPosition.y = window.getSize().y - ( tramina.getSize().y + 25 ) - 20;
                }
                _that.textureMagnifier.setPosition(newPosition);
            });
            
            
            
        }.bind(_that));
        var a = new Element('a',{ class : 'background_el'}).adopt([img,imageViewerIcon]);
        container.adopt(a);
    },
    createLayoutsContainer : function(obj,_callback){
        var _that = this;
        var container = $(obj.stringContainer).getElements('.items_list')[0];
        try{
            var _toRemove = container.getParent().getElements('.empty_el');
            if(_toRemove.length>0) _toRemove.dispose();
        }catch(err){}
        var img = new Element('img',{
            src : obj.image ? obj.image : '/designer/img/gs/item.png',
            styles : {
                width : obj.type === "double" ? 130 : 65
            },
            events : {
                load : _callback,
                dragstart : function(e){
                    var immagine = e.target;
                    try{
                        var effectJson = JSON.decode('['+obj.data+']');
                        e.event.dataTransfer.setData('layouts_data', JSON.encode(effectJson));
                        e.event.dataTransfer.setData('subtype',"layouts");
                        e.event.dataTransfer.setData('data', JSON.encode(effectJson));
                        e.event.dataTransfer.setData('type',obj.type);
                    }catch(err){
                        alert('Unable to use this element: definition incorrect!');
                    }
                }
            }
        });
        var a = new Element('a').adopt(img);
        container.adopt(a);
    },
    buildGraphics : function(data){
        var _that = this;
        Object.each(data,function(el,key){
            var el_container = _that.containers.graphics[key];
            Array.each(el,function(graphicData,idx){
                graphicData.stringContainer = el_container;
                _that.queues["graphics"].totalEls++;
                _that.addToProperQueue(graphicData,{ 
                    queueName : 'graphics'
                });
            });
        });
    },
    buildLayouts : function(data,type){
        var _that = this;
        Object.each(data,function(val,bookType){
            if(bookType != "cover" || currentDesign.product_type != 3){
                var containerObj = _that.containers[type][bookType];
                Object.each(val,function(el,effectType){
                    var container_id = _that.containers[type][bookType][effectType];
                    Array.each(el,function(effectVal,idx){
                        var translatedCategory = effectVal.category == "text" ? "text" : Math.min(effectVal.category,5);
                        var mainContainer = container_id+"_"+translatedCategory;
                        effectVal.stringContainer = mainContainer;
                        _that.queues["layouts"].totalEls++;
                        _that.addToProperQueue(effectVal,{ 
                            queueName : 'layouts'
                        });
                    });
                });
            }
        });
    },
    buildBackgrounds : function(data){
        var _that = this;
        Object.each(data.backgrounds,function(val,backgroundType){
            var container_id = _that.containers.backgrounds[backgroundType];
            Array.each(val,function(bkg,idx){
                bkg.stringContainer = container_id;
                _that.queues["backgrounds"].totalEls++;
                _that.addToProperQueue(bkg,{ 
                    queueName : 'backgrounds'
                });
            });
        });
    }
});    
